import React from 'react'
import MyListBlock from '../../../../UI/list/MyListBlock'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { useEffect } from 'react'
import { getUserName } from '../../../../../helpers/user/UserHelper'

const WriteOffActUser = () => {

	const writeOffAct = useSelector(state => state.writeOff.writeOffAct)

    const [list, setList] = useState([])

    useEffect(() => {
        setListItems()
    }, [writeOffAct.client, writeOffAct.user])

	const setListItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'Відповідальний',
            value: writeOffAct.user ? getUserName({ user: writeOffAct.user }) : '-'
        })
        listTemp.push({
            name: 'Підрозділ',
            // value: supplyOrder.department ? departmentText[supplyOrder.department.type] + ' - ' + supplyOrder.department.department.name : '-'
            value: 
                writeOffAct.departmentType ? writeOffAct.departmentType.name + ' - ' + writeOffAct.department.name : '-'
        })
        // listTemp.push({
        //     name: 'Відповідальний',
        //     value: 
        //         supplyOrder.user ? 
        //             <div>
        //                 {getUserName({ user: supplyOrder.user })}
        //                 <EditUserInSupplyOrderButton 
        //                     supplyOrderId={supplyOrderId} 
        //                     user={supplyOrder.user} 
        //                 />
        //             </div>
        //         :
        //             <EditUserInSupplyOrderButton 
        //                 supplyOrderId={supplyOrderId} 
        //             />
        // })

        setList(listTemp)
    }

  return (
    <MyListBlock
        className={'supplyOrderView__topBlock'}
        text={'Відповідальний'}
        list={list}
    />
  )
}

export default WriteOffActUser